<template>
  <div>
    <answer-render ref="answer" :config="config" :cvtLang="cvtLang">
      <div slot="body">
        <FormItem prop="value" :rules="rules">
          <!-- pc端 -->
          <div v-if="windowType === 'pc'" class="datetime-wrap">
            <el-time-picker
              v-if="config.answerConfig.timeType === '01'"
              v-model="config.value"
              align="center"
              format="HH:mm"
              value-format="HH:mm"
              :editable="false"
              :picker-options="{
                format: 'HH:mm',
                selectableRange: formatRange()
              }"
              :placeholder="cvtLang('tipsPleaseSelect', surveyInfoLang.tipsPleaseSelect) + cvtLang('timeTypeHourMinute', config.timeTypeHourMinute)"
            ></el-time-picker>
            <el-date-picker
              v-else-if="config.answerConfig.timeType === '02'"
              v-model="config.value"
              type="month"
              value-format="yyyy-MM"
              :editable="false"
              format="yyyy-MM"
              :picker-options="pickerOption"
              :placeholder="cvtLang('tipsPleaseSelect', surveyInfoLang.tipsPleaseSelect) + cvtLang('timeTypeYearMonth', config.timeTypeYearMonth)"
            ></el-date-picker>
            <el-date-picker
              v-else-if="config.answerConfig.timeType === '03'"
              v-model="config.value"
              type="date"
              :editable="false"
              value-format="yyyy-MM-dd"
              format="yyyy-MM-dd"
              :picker-options="pickerOption"
              :placeholder="cvtLang('tipsPleaseSelect', surveyInfoLang.tipsPleaseSelect) + cvtLang('timeTypeYearMonthDay', config.timeTypeYearMonthDay)"
            ></el-date-picker>
            <el-date-picker
              v-else-if="config.answerConfig.timeType === '04'"
              v-model="config.value"
              type="datetime"
              :editable="false"
              value-format="yyyy-MM-dd HH:mm"
              format="yyyy-MM-dd HH:mm"
              :placeholder="cvtLang('tipsPleaseSelect', surveyInfoLang.tipsPleaseSelect) + cvtLang('timeTypeYearMonthDayHourMinute', config.timeTypeYearMonthDayHourMinute)"
            ></el-date-picker>
          </div>
          <!-- 手机端 -->
          <div v-if="windowType === 'mobile'" class="datetime-wrap">
            <div class="select-box" @click="showDatetime">
              <span v-if="!fieldValue" class="tips">{{cvtLang('tipsPleaseSelect', surveyInfoLang.tipsPleaseSelect)}}</span>
              <span v-else class="txt">{{ fieldValue }}</span>
              <van-icon name="arrow-down" />
            </div>
            <van-popup v-model="show" get-container=".answer-wrap" safe-area-inset-bottom round position="bottom">
              <!-- 时分 -->
              <van-datetime-picker
                v-if="config.answerConfig.timeType === '01'"
                v-model="currentDate"
                :type="dateType"
                :title="selectTitle"
                :min-hour="minHour"
                :max-hour="maxHour"
                :min-minute="minMinute"
                :max-minute="maxMinute"
                @cancel="show = false"
                @change="timeChange"
                @confirm="confirmSelect"
              >
                <span slot="cancel">{{cvtLang('btnCancel', surveyInfoLang.btnCancel)}}</span>
                <span slot="confirm">{{cvtLang('btnConfirm', surveyInfoLang.btnConfirm)}}</span>
              </van-datetime-picker>
              <!-- 非时分 -->
              <van-datetime-picker
                v-if="config.answerConfig.timeType !== '01'"
                v-model="currentDate"
                :type="dateType"
                :title="selectTitle"
                :min-date="minDate"
                :max-date="maxDate"
                @cancel="show = false"
                @confirm="confirmSelect"
              >
                <span slot="cancel">{{cvtLang('btnCancel', surveyInfoLang.btnCancel)}}</span>
                <span slot="confirm">{{cvtLang('btnConfirm', surveyInfoLang.btnConfirm)}}</span>
              </van-datetime-picker>
            </van-popup>
          </div>
        </FormItem>
      </div>
    </answer-render>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import answerValidate from './answerValidate'
import dateUtil from '@/tools/dateUtil'
import dayjs from 'dayjs'
const past100Date = Date.now() - 1000 * 60 * 60 * 24 * 360 * 100
const future100Date = Date.now() + 1000 * 60 * 60 * 24 * 360 * 100
export default {
  name: 'TimeBoxAnswer',
  props: ['config'],
  data () {
    return {
      show: false,
      fieldValue: '',
      disabledSelect: true,
      minDate: '',
      maxDate: '',
      dateType: 'date',
      dateFormat: 'YYYY-MM-DD',
      minHour: 0,
      maxHour: 0,
      minMinute: 0,
      maxMinute: 0,
      currentDate: new Date(),
      rules: [
        {
          validator: (rule, value, callback) => {
            const errors = answerValidate.validate.bind(this.config)(this).errors
            if (errors.length) {
              return callback(errors)
            }
            return callback()
          }
        }
      ]
    }
  },
  components: {},
  watch: {},
  computed: {
    ...mapGetters(['allQuestionList']),
    ...mapState({
      windowType: ({Question}) => Question.windowType,
      lang: ({Question}) => Question.lang,
      surveyInfoLang: ({Question}) => Question.surveyInfoLang, // 基础语言配置（提示文字、按钮、题型）
      langMap: ({Question}) => Question.langMap
    }),
    selectTitle() {
      const {timeType} = this.config.answerConfig
      let str = ''

      if (timeType === '01') {
        str = this.cvtLang('timeTypeHourMinute', this.config.timeTypeHourMinute)
      } else if (timeType === '02') {
        str = this.cvtLang('timeTypeYearMonth', this.config.timeTypeYearMonth)
      } else if (timeType === '03') {
        str = this.cvtLang('timeTypeYearMonthDay', this.config.timeTypeYearMonthDay)
      } else if (timeType === '04') {
        str = this.cvtLang('timeTypeYearMonthDayHourMinute', this.config.timeTypeYearMonthDayHourMinute)
      }
      return this.cvtLang('tipsPleaseSelect', this.surveyInfoLang.tipsPleaseSelect) + str
    },
    pickerOption () {
      const { paramInt01, paramInt02, timeType, limitRangeInd } = this.config.answerConfig
      return {
        disabledDate (time) {
          let currentStr = ''
          if (limitRangeInd === '0' || (!paramInt01 && !paramInt02)) {
            return currentStr
          }
          if (timeType === '01') {
            currentStr = dateUtil.date2Str(new Date(time.getTime()), 'HHmm')
          } else if (timeType === '02') {
            currentStr = dateUtil.date2Str(new Date(time.getTime()), 'yyyyMM')
            if (paramInt02 && paramInt01) {
              // 有开始有结束
              return !(currentStr >= paramInt02 && currentStr <= paramInt01)
            } else if (paramInt02 && !paramInt01) {
              // 有开始无结束
              let endDate = dayjs(future100Date).format('YYYYMM')
              return !(currentStr >= paramInt02 && currentStr <= endDate)
            } else if (!paramInt02 && paramInt01) {
              // 无开始有结束
              let startDate = dayjs(past100Date).format('YYYYMM')
              return !(currentStr >= startDate && currentStr <= paramInt01)
            }
          } else if (timeType === '03') {
            currentStr = dateUtil.date2Str(new Date(time.getTime()), 'yyyyMMdd')
            if (paramInt02 && paramInt01) {
              // 有开始有结束
              return !(currentStr >= paramInt02 && currentStr <= paramInt01)
            } else if (paramInt02 && !paramInt01) {
              // 有开始无结束
              let endDate = dayjs(future100Date).format('YYYYMMDD')
              return !(currentStr >= paramInt02 && currentStr <= endDate)
            } else if (!paramInt02 && paramInt01) {
              // 无开始有结束
              let startDate = dayjs(past100Date).format('YYYYMMDD')
              return !(currentStr >= startDate && currentStr <= paramInt01)
            }
          } else if (timeType === '04') {
            currentStr = time.getTime()
            if (paramInt02 && paramInt01) {
              // 有开始有结束
              return !(currentStr >= (paramInt02 - 24 * 60 * 60 * 1000) && currentStr <= paramInt01)
            } else if (paramInt02 && !paramInt01) {
              // 有开始无结束
              let endDate = future100Date
              return !(currentStr >= (paramInt02 - 24 * 60 * 60 * 1000) && currentStr <= endDate)
            } else if (!paramInt02 && paramInt01) {
              // 无开始有结束
              let startDate = past100Date
              return !(currentStr >= startDate && currentStr <= paramInt01)
            }
          }
          return !(currentStr >= (paramInt02 - 24 * 60 * 60 * 1000) && currentStr <= paramInt01)
        }
      }
    }
  },
  methods: {
    formatRange () {
      const { paramInt01, paramInt02, limitRangeInd } = this.config.answerConfig
      if (limitRangeInd === '0' || (!paramInt01 && !paramInt02)) {
        return ''
      }
      const date1Str = paramInt01 ? `${paramInt01.substring(0, 2)}:${paramInt01.substring(2, 4)}:00` : '23:59:00'
      const date2Str = paramInt02 ? `${paramInt02.substring(0, 2)}:${paramInt02.substring(2, 4)}:00` : '00:00:00'
      return `${date2Str} - ${date1Str}`
    },
    // 展示地址
    showDatetime() {
      this.show = true
    },
    confirmSelect() {
      const {timeType} = this.config.answerConfig
      this.show = false
      if (timeType === '01') {
        // 时分
        this.fieldValue = this.currentDate
      } else {
        // 非时分
        this.fieldValue = dayjs(this.currentDate).format(this.dateFormat)
      }

      this.config.value = this.fieldValue
    },
    // 时分改变
    timeChange() {
      const {paramInt01, paramInt02} = this.config.answerConfig
      const currHour = parseInt(this.currentDate.substring(0, 2))
      if (currHour > this.minHour) {
        this.minMinute = '00'
        if (currHour < this.maxHour) {
          this.maxMinute = 59
        } else if (currHour === this.maxHour) {
          this.maxMinute = parseInt(paramInt01.substring(2, 4))
        }
      } else if (currHour === this.minHour) {
        this.minMinute = parseInt(paramInt02.substring(2, 4))
        this.maxMinute = paramInt01 ? parseInt(paramInt01.substring(2, 4)) : '59'
        if (this.minMinute > this.maxMinute) {
          this.maxMinute = 59
        }
        if (currHour < this.maxHour) {
          this.maxMinute = 59
        }
      } else if (currHour === this.maxHour) {
        this.maxMinute = parseInt(paramInt01.substring(2, 4))
      }
    },
    // 设置时间范围
    setTimeRange() {
      const {paramInt01, paramInt02, limitRangeInd} = this.config.answerConfig
      if (limitRangeInd === '0') {
        // 验证范围关闭
        this.minMinute = '00'
        this.maxMinute = '59'
        this.minHour = '01'
        this.maxHour = '23'
        return
      }
      this.minHour = paramInt02 ? parseInt(paramInt02.substring(0, 2)) : '01'
      this.minMinute = paramInt02 ? parseInt(paramInt02.substring(2, 4)) : '01'
      this.maxHour = paramInt01 ? parseInt(paramInt01.substring(0, 2)) : '23'
      if (this.minHour === this.maxHour) {
        this.maxMinute = paramInt01 ? parseInt(paramInt01.substring(2, 4)) : 59
      } else {
        this.maxMinute = paramInt01 ? parseInt(paramInt01.substring(2, 4)) : 59
        if (this.minMinute > this.maxMinute) {
          this.minMinute = '00'
        } else {
          this.minMinute = '00'
        }
      }
    },
    initConfig() {
      const {timeType, limitRangeInd, paramInt01, paramInt02} = this.config.answerConfig
      if (limitRangeInd === '0') {
        this.minDate = new Date(dayjs(past100Date).format('YYYY/MM/DD'))
        this.maxDate = new Date(dayjs(future100Date).format('YYYY/MM/DD'))
      } else {
        this.minDate = new Date(dayjs(paramInt02 ? paramInt02 : (past100Date)).format('YYYY/MM/DD'))
        this.maxDate = new Date(dayjs(paramInt01 ? paramInt01 : (future100Date)).format('YYYY/MM/DD'))
      }
      if (timeType === '01') {
        this.dateType = 'time'
        this.dateFormat = 'HH:mm'
        this.currentDate = dayjs(new Date()).format(this.dateFormat)
        this.setTimeRange()
      } else if (timeType === '02') {
        this.dateType = 'year-month'
        this.dateFormat = 'YYYY-MM'
      } else if (timeType === '03') {
        this.dateType = 'date'
        this.dateFormat = 'YYYY-MM-DD'
      } else if (timeType === '04') {
        this.dateType = 'datetime'
        this.dateFormat = 'YYYY-MM-DD HH:mm'
        if (limitRangeInd === '0') {
          this.minDate = new Date(dayjs(past100Date).format('YYYY/MM/DD'))
          this.maxDate = new Date(dayjs(future100Date).format('YYYY/MM/DD'))
        } else {
          this.minDate = new Date(dayjs(paramInt02 ? paramInt02 : (past100Date)).format('YYYY/MM/DD HH:mm'))
          this.maxDate = new Date(dayjs(paramInt01 ? paramInt01 : (future100Date)).format('YYYY/MM/DD HH:mm'))
        }
      }
    },
    // TODO 引用/继承
    isOrigin () {
      return this.lang === 'origin'
    },
    // TODO 引用/继承
    cvtLang: function (id, title) {
      if (this.isOrigin()) {
        return title
      }
      const {lang, langMap} = this
      const key = `${id}_${lang}`
      const value = langMap[key]
      if (!value) {
        this.$set(langMap, key, '')
      }
      return langMap[key]
    }
  },
  created () {},
  mounted () {
    if (this.config.value) {
      this.fieldValue = this.config.value
    }
    this.initConfig()
  }
}
</script>
<style lang="scss" scoped>
.datetime-wrap {
  margin-top: 40px;
}
.select-box {
  display: flex;
  flex: 1;
  justify-content: space-between;
  align-items: center;
  border: 1px solid #ccc;
  padding: 0 16px;
  border-radius: 4px;
  .txt {
    overflow:hidden;
    white-space:nowrap;
    text-overflow:ellipsis;
    width:100%;
    max-width: 70vw;
    display: inline-block;
  }
  .tips {
    color: #bbb;
  }
  .van-icon {
    color: #ccc;
  }
}
.answer-pc {
  .datetime-wrap {
    margin-top: 10px;
    >>> .el-date-editor {
      height: 32px;
      .el-input__inner {
        height: 32px;
        border-radius: 0px;
      }
      .el-input__icon {
        line-height: 32px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/editor/TimeBox/TimeBoxAnswer.vue